<template>
	<div id="loginForm">
		<Form ref="loginForm" :model="loginForm" :rules="loginRule">
			<FormItem prop="user">
				<Input prefix="md-person" placeholder="请输入账号/手机号" size="large" v-model="loginForm.user" />
			</FormItem>
			<FormItem prop="password">
				<Input type="password" prefix="md-lock" size="large" placeholder="请输入密码" v-model="loginForm.password" />
			</FormItem>
			<FormItem prop="verify" class="verifyCode">
				<Input class="verifyEnter" type="text" size="large" prefix="md-apps" placeholder="请输入验证码"
					v-model="loginForm.verify" />
				<div class="codeImg">
					<img :src="codeUrl" @click="getCodeImg">
				</div>
			</FormItem>
			<FormItem>
				<Button type="primary" style="background-color:#115467;" size="large" @click="loginSubmit('loginForm')"
					long>登录</Button>
				<div class="loginTips">
					<div class="loginTipsForget">
						<!-- <a>忘记密码?</a> -->
					</div>
				</div>
			</FormItem>
		</Form>
	</div>
</template>

<script>
	import {
		userAuthCode,
		userLogin,
		knowledgeIsCollect,
		userDetails
	} from '../../request/api.js';
	import {
		setToken
	} from '../../libs/util.js';
	import {
		encrypt
	} from '../../libs/rsaEncrypt.js';
	export default {
		data() {
			return {
				codeUrl: '',
				loginForm: {
					user: '',
					password: '',
					verify: ''
				},
				loginRule: {
					user: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入账号密码',
						trigger: 'blur'
					}],
					verify: [{
						required: true,
						message: '请输入图形验证码',
						trigger: 'blur'
					}]
				},
			}
		},
		methods: {
			getCodeImg() {
				userAuthCode().then(res => {
					this.codeUrl = res.img
					this.loginForm.uuid = res.uuid
				})
			},
			loginSubmit(name) {
				var _this = this;
				_this.$refs[name].validate((valid) => {
					if (valid) {
						var loginNum = _this.loginForm.user;
						var loginPhone;
						loginNum = loginNum.toLowerCase();
						if (loginNum.indexOf("vip") != -1) {
							var num = loginNum.replace(/[^\d]/g, '');
							loginPhone = '188888888' + num
						} else {
							loginPhone = loginNum
						}
						let logindata = {
							username: loginPhone,
							password: encrypt(_this.loginForm.password),
							code: _this.loginForm.verify,
							uuid: _this.loginForm.uuid
						};
						userLogin(logindata).then(res => {
							setToken(JSON.stringify(res.token))
							setTimeout(() => {
								_this.getUserInfo()
							}, 200)
						}).catch(error => {
							_this.$Message.error(error.message);
							_this.getCodeImg()
							_this.$refs[name].resetFields();
						})
					} else {
						_this.$Message.error('必填不可为空');
					}
				})
			},
			// 获取用户信息
			getUserInfo() {
				userDetails().then(userres => {
					// 收藏
					let sc = userres.member.collects;
					let scVideo = {
						scNum: sc.length,
						scList: sc
					}
					// 预约
					let yy = userres.member.orders;
					let yyVideo = {
						yyNum: yy.length,
						yyList: yy
					}
					// 知识库
					let zskSc = [];
					knowledgeIsCollect(userres.member.memberId).then(knowres => {
						zskSc = knowres
					}).catch(err => {
						zskSc = []
					})
					let scZsk = {
						zskScNum: zskSc.length,
						zskScList: zskSc
					}
					const ArxsysUser = {
						loginName: userres.member.loginName,
						nickname: userres.member.nickname,
						type: userres.member.type,
						integral: userres.member.integral,
						photo: userres.member.photo,
						memberId: userres.member.memberId,
						scVideo: scVideo,
						yyVideo: yyVideo,
						scZsk: scZsk
					};
					this.$store.commit('updateUserData', ArxsysUser)
					this.$Message.success('你好，欢迎登录!');
					setTimeout(() => {
						// this.$parent.backpath();
						this.$router.push('/')
					}, 1000)
				})
			}
		},
		created() {
			this.getCodeImg()
		}
	}
</script>

<style>
	#loginForm {
		width: 300px;
		margin: 40px auto;
	}

	.codeInput {
		width: 60%;
	}

	.codeBtn {
		width: 39%;
		margin-left: 1%;
	}

	.verifyCode .ivu-form-item-content {
		display: flex !important;
		flex-direction: inherit;
		align-items: center;
		justity-content: center;
	}

	.verifyEnter {
		width: 60%;
	}

	.codeImg {
		height: 42px;
		width: 39%;
		display: inline-block;
	}

	.codeImg img {
		/* height: 100%; */
		width: 100%;
	}
</style>